import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import CookieConsent from "@/components/layout/CookieConsent";
import { useLenis } from "@/hooks/useLenis";
import { AnimatePresence, motion } from "framer-motion";
import { useLocation } from "react-router-dom";

export default function Layout({ children }) {
  useLenis();
  const loc = useLocation();
  return (
    <div className="App">
      <div className="grain" aria-hidden="true" />
      <Navbar />
      <AnimatePresence mode="wait">
        <motion.main
          key={loc.pathname}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: [0.76, 0, 0.24, 1] }}
        >
          {children}
        </motion.main>
      </AnimatePresence>
      <Footer />
      <CookieConsent />
    </div>
  );
}
